import styled from "styled-components";

export const ImageStyled = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
